<page-title [title]="title"></page-title>
<p>Consulte e gerencie suas formas de pagamento:</p>
<mat-tab-group>
  <mat-tab label="Ativas">
    <div class="col-xs-12" *ngFor="let method of methodActive">
      <mat-card (click)="openPaymentMethodDetail(method)">
        <mat-icon color="primary" *ngIf="method?.icon">{{ method?.icon }}</mat-icon> {{ method.name }}
        <div *ngIf="method.flags">
          <b>Bandeiras:</b>
          <span *ngFor="let flag of method.flags; let i = index">
            <span *ngIf="i > 0">,</span>
            {{ flag.name }}
          </span>
        </div>
      </mat-card>
    </div>
  </mat-tab>

  <mat-tab label="Inativas">
    <div class="col-xs-12" *ngFor="let method of methodInactive">
      <mat-card (click)="openPaymentMethodDetail(method)">
        <mat-icon color="primary" *ngIf="method?.icon">{{ method?.icon }}</mat-icon> {{ method.name }}
        <div *ngIf="method.flags">
          <b>Bandeiras:</b>
          <span *ngFor="let flag of method.flags; let i = index">
            <span *ngIf="i > 0">,</span>
            {{ flag.name }}
          </span>
        </div>
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>

<form [formGroup]="paymentForm" (ngSubmit)="savePaymentSettings()">
  <div class="col-xs-12">
    <mat-form-field appearance="outline">
      <mat-label>Percentual de comissão da secretária (%)</mat-label>
      <input matInput type="number" formControlName="secretary_commission_percentage" min="0" max="99" />
      <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('required')">
        O percentual de comissão é obrigatório.
      </mat-error>
      <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('pattern')"> Informe um valor inteiro. </mat-error>
      <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('min')"> O percentual deve ser maior ou igual a 0. </mat-error>
      <mat-error *ngIf="paymentForm.get('secretary_commission_percentage')?.hasError('max')"> O percentual deve ser menor ou igual a 99. </mat-error>
    </mat-form-field>
  </div>
  <div class="col-xs-12">
    <p>Percentual principal: {{ mainPercentage }}%</p>
  </div>
  <div class="col-xs-12">
    <button mat-raised-button color="primary" type="submit" [disabled]="paymentForm.invalid">Salvar</button>
  </div>
</form>
